import React from 'react'
import UploadModal from '../../components/uploadModal'
import Gallery from '../../components/imageGallery/gallery'
import { useSelector, useDispatch } from 'react-redux'
import { useCarromm } from '../../context/carromm'
import Heading from '../../components/heading/Heading'
import { setPreviewImages } from '../../redux/slices/carrommSlice';

const Home = () => {
  const {previewImages, dimension} = useSelector(state => state.carromm);
  const carrom = useCarromm();
  const dispatch = useDispatch();

  const handleNext = () => {
    if(dimension !== "") {
      let comparer = (dimension === "2D") ? "backgrounds" : "showroom";
      carrom.setTabs(carrom.tabs.map((t) => ({ ...t, active: t.id === comparer })));
    }
  };

  const handleCancel = () => {
    carrom.setInput(null);
    dispatch(setPreviewImages(null))
  };

  return (
    <>
      <Heading/>
      <UploadModal
        handleClick={handleNext}
        handleCancel={handleCancel} />
      {previewImages &&
        <Gallery
          items={previewImages}
          title={'Bilder hochladen'} />}
    </>
  )
}

export default Home
